import React from 'react'

import { LntButton } from '@app/components/base'
import { Icon } from '@app/components/util'

import { BUTTON_TYPE, ICON_SIZE, SIZE } from '@app/constants'
import { ICON_NAME } from '@app/constants/icon'

import type { DeleteButtonRendererProps } from './types'

export const DeleteButtonRenderer: React.FC<DeleteButtonRendererProps> = ({ rowKey, onClick }) => {
  return (
    <LntButton
      type={ BUTTON_TYPE.link }
      size={ SIZE.small }
      onClick={ () => onClick?.(rowKey) }
    >
      <Icon
        name={ ICON_NAME.delete }
        size={ ICON_SIZE }
      />
    </LntButton>
  )
}
